import { faAlignRight } from '@fortawesome/free-solid-svg-icons';
import React, { Component } from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';
import { API_ENDPOINT } from '../../../constants';

import { Tooltip } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";

import xIcon from '../../../assets/svg/x.svg';

import multiIcon from '../../../assets/svg/multi.svg';
import handled from '../../../assets/svg/check.svg'

import Isvg from 'react-inlinesvg'

import moment from 'moment';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label, Table
} from 'reactstrap';
import { getBackgroundColorForEvent, getTextColor } from '../../../helpers/colors';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "rgba(58, 63, 85, 0.9)",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14,
        minWidth: 500
    }
}))(Tooltip);
const LightTooltipCheckIn = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "rgba(58, 63, 85, 0.9)",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14,
        // minWidth: 500
    }
}))(Tooltip);

const LightTooltipHoliday = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#e61f00",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);

function getTitle(text, view) {
    let returnValue = '';

    if ((view == 'month' || view == 'work_week') && text && text.length > 20) {
        returnValue = text.substr(0, 20) + '...'
    } else if (view == 'week' && text && text.length > 15) {
        returnValue = text.substr(0, 15) + '...'
    } else if (view == 'day') {
        returnValue = text;
    } else if (text && text.length > 40 && false) {
        returnValue = text.substr(0, 37) + '...'
    } else {
        returnValue = text;
    }




    return returnValue;
}
/**
* Component for custom events in calendar
* @author   Aleksandar Dabic
*/
class EventComponent extends Component {
    constructor(props) {
        super(props);


        this.state = {

            referral: null,
            note: this.props.event.patientNote,
            controlNote: this.props.event.patientControlNote,
            tooltip: this.props.event.tooltip
        };
    }


    componentDidMount() {
        const view = this.props.view;
    }

    highlightedText = (text, search) => {
        if (!search) return <p>{text}</p>;

        const parts = text.split(new RegExp(`(${search})`, 'gi'));
        return (
            <p>
                {parts.map((part, index) =>
                    part.toLowerCase() === search.toLowerCase() ? (
                        <strong key={index}>{part}</strong>
                    ) : (
                        part
                    )
                )}
            </p>
        );
    }

    render() {

        let daysWithDuplicate = [];
        if (this.props.daysWithDuplicate && this.props.view == 'month') {
            daysWithDuplicate = this.props.daysWithDuplicate;
        }
        const fromAnotherClinic = this.props?.event?.clinic !== this.props.selectedClinic ? true : false;

        let isTeam = null;
        if (this.props.view !== 'month' && this.props.selectedGroup === this.props.event?.group && this.props.selectedClinic === this.props.event?.clinic && ['referral', 'revisit'].includes(this.props.event?.type)) {
            let e = this.props.event;
            if (e?.additionalDoctors && Array.isArray(e.additionalDoctors) && e.additionalDoctors.length > 0) {
                let bgColor = getBackgroundColorForEvent(e, this.props.selectedGroup, this.props.selectedClinic);
                let color = getTextColor(bgColor);

                isTeam = color;
            }
        }

        return (
            this.props.event?.allDay ?
                (
                    <div style={this.props.view === 'day' ? { position: 'relative', maxWidth: 200 } : { position: 'relative' }}>
                        <LightTooltipHoliday title={this.props.lang === 'en' && this.props.event.titleEn ? this.props.event.titleEn.trim() : this.props.event.title.trim()} placement="top-start" >
                            <div className="rbc-event-label" style={{ display: 'flex', backgroundColor: '#e7e7e7', borderTopRightRadius: '5px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px', color: '#000', }}>
                                <div style={{ backgroundColor: '#e61f00', height: 20, minWidth: 10 }}></div>
                                <div style={{ paddingLeft: 5, maxWidth: 200, fontSize: '14px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{this.props.lang === 'en' && this.props.event.titleEn ? this.props.event.titleEn.trim() : this.props.event.title.trim()}</div>

                            </div>
                        </LightTooltipHoliday>
                    </div>
                )
                :
                (
                    <div className="rbc-container" key={this.props.event.id} onContextMenu={(e) => {
                        e.preventDefault();
                        if (['agenda', 'day', 'week', 'work_week', 'month'].includes(this.props.view) && ['temporaryEvent', 'holiday', 'free', 'template'].indexOf(this.props.event.type) === -1) {
                            this.props.markAsDone(!this.props.event?.isMarkedAsDone, this.props.event.id);
                        }
                    }}>
                        {
                            this.props.view == 'month' && this.props.event.start && this.props.getStringDateTs(new Date(this.props.event.start).getTime() / 1000, 'MM-DD-YYYY')/*moment.unix(new Date(this.props.event.start).getTime() / 1000).format('MM-DD-YYYY')*/ && daysWithDuplicate.filter(el => el == this.props.getStringDateTs(new Date(this.props.event.start).getTime() / 1000, 'MM-DD-YYYY')/*moment.unix(new Date(this.props.event.start).getTime() / 1000).format('MM-DD-YYYY')*/).length ?
                                <div className='duplicate-events-month-view-wrap'>
                                    <div className='duplicate-events-month-view-icon-wrap' onClick={(e) => {
                                        e.stopPropagation()
                                        this.props.setView('agenda', this.props.event.start)
                                    }}>
                                        <div className='svg-wrap'>
                                            <Isvg src={multiIcon} />
                                        </div>
                                        <div className='duplicate-events-tooltip'>
                                            {'Overlapping bookings, see agenda!'.translate(this.props.lang)}
                                        </div>

                                    </div>
                                </div>
                                :
                                null
                        }


                        <Container>
                            <Row style={{ 'padding-bottom': '10px', 'align-items': 'center' }}>
                                <Col lg={this.props.view == 'agenda' ? '6' : '12'} style={
                                    this.props.event?.isMarkedAsDone && this.props.view === 'agenda' ?
                                        { overflow: 'hidden', paddingLeft: isTeam ? 20 : 0, textDecorationLine: 'line-through', textDecorationThickness: 3 } :
                                        this.props.isClinicInJournal && this.props.event.isMarkedForCheckIn ?
                                            { overflow: 'hidden', paddingLeft: isTeam ? 20 : 0, display: 'flex', gap: 6 } : { overflow: 'hidden', paddingLeft: isTeam ? 20 : 0, }
                                }>
                                    {isTeam ? <span
                                        color={isTeam}
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                        }}
                                        title={'Includes other caregivers'.translate(this.props.lang)}
                                    >
                                        <PeopleIcon />
                                    </span> : null}
                                    {
                                        this.props.isClinicInJournal && this.props.event.isMarkedForCheckIn ?
                                            <div >
                                                <LightTooltipCheckIn title={'Checked in'.translate(this.props.lang)} placement="top-start" >
                                                    <div>
                                                        <Isvg src={handled} width={16} height={16} />
                                                    </div>
                                                </LightTooltipCheckIn>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        this.props.event.patientProfile && this.props.view == 'agenda' ?
                                            (!this.props.event.tooltipDisabled || true) && this.props.event.type != 'temporaryEvent' && this.props.selectedClinic === this.props.event.clinic ?
                                                <LightTooltip title={this.state.tooltip} placement="top-start">
                                                    <div
                                                        color='#fff'
                                                        className="event-name-button"
                                                        style={{ padding: 0 }}
                                                        onClick={() => {
                                                            this.props.selectedEvent(this.props.event)
                                                            // this.props.setPatientProfile(this.props.event.patientProfile)
                                                        }}
                                                    >
                                                        <p style={this.props.event?.isMarkedAsDone ? { textDecorationLine: 'line-through', textDecorationThickness: 3 } : {}} >
                                                            {getTitle(this.props.event.title, this.props.view)}
                                                        </p>
                                                    </div>
                                                </LightTooltip>
                                                :
                                                <p style={this.props.event?.isMarkedAsDone ? { textDecorationLine: 'line-through', textDecorationThickness: 3 } : {}}>{this.props.event.title}</p>
                                            :
                                            (!this.props.event.tooltipDisabled || true) && this.props.event.type != 'temporaryEvent' && this.props.selectedGroup === this.props.event.group && (this.props.view == 'agenda' ? this.props.selectedClinic === this.props.event.clinic : true) ?
                                                <LightTooltip title={this.state.tooltip} placement="top-start">
                                                    {/* <p >{getTitle(this.props.event.title, this.props.view)}</p> */}
                                                    {this.highlightedText(getTitle(this.props.event.title, this.props.view), this.props.searchParam)}
                                                </LightTooltip>

                                                :
                                                <p >{this.props.event.title}</p>

                                    }
                                </Col>
                                <Col lg="3" style={{ overflowX: 'hidden', paddingLeft: 0 }}>

                                    {
                                        this.props.event.patientNote && this.props.view == 'agenda' && !fromAnotherClinic ?
                                            <div>
                                                {this.props.event.patientNote}
                                            </div>
                                            :
                                            (this.props.event.type == "control" || this.props.event.type === 'revisit') && this.props.view == 'agenda' && !fromAnotherClinic ?
                                                <div>
                                                    {this.props.event.patientControlNote}
                                                </div>
                                                :
                                                null
                                    }
                                </Col>
                                <Col lg="3" style={{ overflowX: 'hidden', display: 'flex', justifyContent: 'flex-end', }}>
                                    {
                                        this.props.event.referral && this.props.view == 'agenda' && !fromAnotherClinic ?
                                            <Button style={{ background: '#E6EDF5', color: "black", whiteSpace: 'nowrap', width: 'auto', maxWidth: '100%' }} onClick={() => this.props.setReferral(this.props.event.referral, this.state.note, this.props.event.title)}>{'Add note'.translate(this.props.lang)}</Button>
                                            :
                                            (this.props.event.type == "control" || this.props.event.type === 'revisit') && this.props.view == 'agenda' && !fromAnotherClinic ?
                                                <Button style={{ background: '#E6EDF5', color: "black", whiteSpace: 'nowrap', width: 'auto', maxWidth: '100%' }} onClick={() => this.props.setControl(this.props.event.id, this.state.controlNote, this.props.event.title)}>{'Add note'.translate(this.props.lang)}</Button>
                                                :
                                                null
                                    }
                                </Col>
                            </Row>
                        </Container>
                    </div>
                )
        );
    }
}

export default EventComponent;

const PeopleIcon = () => {
    if (typeof window === 'undefined') return null;
    return <svg style={{ display: 'inline-block' }} width={14} height={14} fill='currentColor' enableBackground="new 0 0 24 24" id="Layer_1" version="1.0" viewBox="0 0 24 24" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><g><g><path d="M16.5,14c-1.5,0-2.7,0.4-3.6,0.9c1.4,1.2,2,2.6,2.1,2.7l0.1,0.2V20h8v-2C23,18,21.4,14,16.5,14z" /></g><g><circle cx="16.5" cy="8.5" r="3.5" /></g></g><g><path d="M4,8.5C4,6.6,5.6,5,7.5,5S11,6.6,11,8.5c0,1.9-1.6,3.5-3.5,3.5S4,10.4,4,8.5z M7.5,14C2.6,14,1,18,1,18v2h13v-2   C14,18,12.4,14,7.5,14z" /></g></svg>
}

function hexToRgba(hex, alpha = 1) {
    hex = hex.replace(/^#/, '');

    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    const bigint = parseInt(hex, 16);
    const red = (bigint >> 16) & 255;
    const green = (bigint >> 8) & 255;
    const blue = bigint & 255;

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}